<template>
  <div class="l-step-dev-box">
    <div class="l-table-toolbar">
      <l-auth-text-button type="primary" auth="dev_type_add_btn" @click="showAdd(0)">
        添加设备类型
      </l-auth-text-button>
      <l-auth-text-button type="primary" auth="dev_type_add_btn" @click="showSelect()">
        从通用设备类型中选择
      </l-auth-text-button>
    </div>
    <l-table :data="data" v-loading="loading" row-key="id" default-expand-all :tree-props="{children: 'children', hasChildren: 'hasChildren'}" height="400px">
      <el-table-column prop="name" label="设备名称" min-width="180">
      </el-table-column>
      <el-table-column prop="img_icon" label="设备图标" min-width="120">
        <template v-slot="{row}">
          <img class="l-table-img" :src="row.img_icon" />
        </template>
      </el-table-column>
      <el-table-column prop="level" label="层级" min-width="100">
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="250" align="center">
        <template slot-scope="{row}">
          <l-auth-text-button type="primary" :auth="row.level==1?'dev_type_add_btn':''" @click="showAdd(row.id)"><i class="el-icon-plus"></i>新增下级</l-auth-text-button>
          <span class="l-action-separator">|</span>
          <l-auth-text-button type="primary" auth="dev_type_edit_btn" @click="showEdit(row.id)"><i class="el-icon-edit"></i>编辑</l-auth-text-button>
          <span class="l-action-separator">|</span>
          <l-auth-text-button type="danger" auth="dev_type_del_btn" @click="del(row.id)"><i class="el-icon-delete"></i>删除</l-auth-text-button>
        </template>
      </el-table-column>
    </l-table>

    <div style="margin-top:20px;text-align:center">
      <el-button type="primary" :loading="submitting" @click="handleSubmit">完成</el-button>
      <el-button @click="lastStep">上一步</el-button>
    </div>

    <!--添加弹窗-->
    <l-dialog :visible.sync="add_visible" title="添加设备类型" width="500px">
      <l-dev-type-edit @on-success="onAddSuccess" :visible.sync="add_visible" :pid="pid" :company-id="orgId" />
    </l-dialog>

    <!--编辑弹窗-->
    <l-dialog :visible.sync="edit_visible" title="编辑设备类型" width="500px">
      <l-dev-type-edit @on-success="onEditSuccess" :visible.sync="edit_visible" :id="edit_id" />
    </l-dialog>

    <!--通用设备类型弹窗-->
    <l-dialog :visible.sync="select_visible" title="通用设备类型" width="700px">
      <l-dev-type-common-list @on-success="onCheckedSuccess" :visible.sync="select_visible" :org-id="orgId" :checked-ids="checked_ids" />
    </l-dialog>
  </div>
</template>

<script>
  import Edit from '../dev_type/Edit';
  import CommonList from '../dev_type/CommonList'
  export default {
    name: 'l-company-add-step3',
    props: {
      orgId: {
        type: [Number, String]
      }
    },
    components: {
      [Edit.name]: Edit,
      [CommonList.name]: CommonList,
    },
    data() {
      return {
        data: [],
        loading: false,
        submitting: false,

        checked_ids:[],

        add_visible: false,//是否显示添加
        pid: '',

        edit_visible: false,//是否显示编辑
        edit_id: 0,

        select_visible: false,//通用设备类型
      }
    },
    mounted() {
      this.getList();
    },
    methods: {
      //获取列表数据
      getList() {
        this.loading = true;
        this.$_invoke('devType_getListByCompanyId', {
          page: this.page,
          page_size: this.page_size,
          company_id: this.$props.orgId
        }).then(ret => {
          this.data = ret.data;
        }).finally(() => {
          this.loading = false;
        })
      },

      //显示添加
      showAdd(pid) {
        this.pid = pid;
        this.add_visible = true;
      },

      //添加成功回调
      onAddSuccess() {
        this.pid = '';
        this.add_visible = false;
        this.getList();
      },


      //显示编辑
      showEdit(id) {
        this.edit_id = id;
        this.edit_visible = true;
      },

      //编辑成功回调
      onEditSuccess() {
        this.edit_id = '';
        this.edit_visible = false;
        this.getList();
      },

      //删除
      del(id) {
        this.$confirm('确定删除该设备类型吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          this.$_invoke(`devType_delete`, { id }).then(() => {
            this.$_msg.success('删除成功');
            this.getList();
          });
        }).catch(() => {
        });
      },

      //提交
      handleSubmit() {
        this.$emit('on-success');
      },

      //点击上一步
      lastStep() {
        this.$emit('on-click-last-step');
      },


      //显示通用设备类型选择
      showSelect() {
        this.select_visible = true;
      },

      //从通用设备类型中选择回调成功
      onCheckedSuccess(checked_ids){
        this.select_visible=false;
        this.checked_ids=checked_ids;
        this.getList();
      }
    }
  }
</script>

<style lang="scss" scoped>
  .l-step-dev-box {
    margin-top: 30px;
  }
</style>